function sum(array) {
	return array.reduce( (x, y) => x+y, 0);
}

module.exports = sum;